(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-accordeon"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.querySelector('.faq-accordion-wrapper');
  if (!wrapper) return;
  const items = wrapper.querySelectorAll('.faq-item');
  const toggle = wrapper.querySelector('.faq-toggle-container .faq-toggle-link');
  const limit = 4;

  if (toggle) {
    toggle.addEventListener('click', function() {
      const hidden = Array.from(items).filter((el, i) => i >= limit && el.style.display === 'none');
      const finalBlock = wrapper.querySelector('.faq-final-text');
      if (hidden.length) {
        hidden.forEach(el => el.style.display = 'block');
        toggle.textContent = 'Afficher moins';
        if(finalBlock) finalBlock.style.display = 'block';
      } else {
        items.forEach((el, i) => { if (i >= limit) el.style.display = 'none'; });
        toggle.textContent = 'Afficher plus';
        if(finalBlock) finalBlock.style.display = 'none';
      }
    });
  }

  wrapper.addEventListener('click', function(event) {
    const summary = event.target.closest('summary');
    if (!summary || !wrapper.contains(summary)) return;
    const currentDetail = summary.parentElement;
    wrapper.querySelectorAll('details').forEach(detail => {
      if (detail !== currentDetail && detail.hasAttribute('open')) {
        detail.removeAttribute('open');
      }
    });
  });

  wrapper.addEventListener('keydown', function(event) {
    const summary = event.target.closest('summary');
    if (!summary || (event.key !== 'Enter' && event.key !== ' ')) return;
    const currentDetail = summary.parentElement;
    wrapper.querySelectorAll('details').forEach(detail => {
      if (detail !== currentDetail && detail.hasAttribute('open')) {
        detail.removeAttribute('open');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotion-countdown"] && !Shopify.designMode) return;
  try {
    
const padCountdownValue=value=>String(value).padStart(2,'0');const updatePromotionCountdown=countdown=>{const end=new Date(countdown.dataset.countdownEnd).getTime();const distance=end-Date.now();const ended=countdown.parentElement.querySelector('[data-countdown-ended]');if(Number.isNaN(end))return;if(distance<=0){countdown.hidden=true;ended.hidden=false;ended.textContent=countdown.dataset.endedText;return}countdown.hidden=false;ended.hidden=true;countdown.querySelector('[data-countdown-days]').textContent=padCountdownValue(Math.floor(distance/86400000));countdown.querySelector('[data-countdown-hours]').textContent=padCountdownValue(Math.floor(distance%86400000/3600000));countdown.querySelector('[data-countdown-minutes]').textContent=padCountdownValue(Math.floor(distance%3600000/60000));countdown.querySelector('[data-countdown-seconds]').textContent=padCountdownValue(Math.floor(distance%60000/1000))};const refreshPromotionCountdowns=()=>{document.querySelectorAll('[data-promotion-countdown]').forEach(updatePromotionCountdown)};refreshPromotionCountdowns();setInterval(refreshPromotionCountdowns,1000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotion-hero"] && !Shopify.designMode) return;
  try {
    
const updateCountdowns=()=>{document.querySelectorAll('[data-countdown]').forEach(countdown=>{const value=countdown.querySelector('[data-countdown-value]');const end=new Date(countdown.dataset.countdown).getTime();const distance=end-Date.now();if(!value||Number.isNaN(end))return;if(distance<=0){value.textContent=countdown.dataset.endedText;return}const days=Math.floor(distance/86400000);const hours=Math.floor(distance%86400000/3600000);const minutes=Math.floor(distance%3600000/60000);const seconds=Math.floor(distance%60000/1000);value.textContent=`${days}j ${hours}h ${minutes}m ${seconds}s`})};updateCountdowns();setInterval(updateCountdowns,1000);

  } catch(e) { console.error(e); }
})();
})();
